<template>
  <div
    class="add-visite"
    :class="{ isEnglish: $isEnglish }"
  >
    <p
      ref="visibleEle"
      class="visibleEle"
    />

    <p
      v-if="recycleRuleTips"
      class="recycle-rule-tips fs-warning"
    >
      {{ recycleRuleTips }}
    </p>
    <div
      ref="form"
      class="form needsclick"
    >
      <!-- 信息分级 -->
      <my-item
        v-if="configAddfields.includes('info_level') && fields['info_level'] && Object.keys(fields['info_level']).length"
        key="info_level"
        ref="item_info_level"
        :data="fields['info_level']"
        @change="handleChangeItem"
      />
      <!-- 信息类型 -->
      <my-item
        v-if="configAddfields.includes('info_type') && fields['info_type'] && Object.keys(fields['info_type']).length"
        key="info_type"
        ref="item_info_type"
        :data="fields['info_type']"
        @change="handleChangeItem"
      />
      <!-- 无效信息 -->
      <div
        v-if="invalidInfo && invalidInfo.child && invalidInfo.child.length && showInvalid"
        class="invalid-info"
      >
        <my-item
          v-for="item in invalidInfo.child"
          :key="item.fieldkey"
          :ref="`item_${item.fieldkey}`"
          :data="fields[item.fieldkey]"
          @change="handleChangeChildItem($event, 'invalid_info')"
        />
      </div>
      <!-- 跟进状态 -->
      <my-item
        v-if="configAddfields.includes('info_status') && fields['info_status'] && Object.keys(fields['info_status']).length"
        key="info_status"
        ref="item_info_status"
        :data="fields['info_status']"
        @change="handleChangeItem"
      />
      <!-- 成交信息 -->
      <div
        v-if="dealInfo && dealInfo.child && dealInfo.child.length && showDealInfo"
        class="deal-info"
      >
        <my-item
          v-for="item in dealInfo.child"
          :key="item.fieldkey"
          :ref="`item_${item.fieldkey}`"
          :data="fields[item.fieldkey]"
          @change="handleChangeChildItem($event, 'deal_info')"
        />
      </div>
      <!-- 丢单信息 -->
      <div
        v-if="discardInfo && discardInfo.child && discardInfo.child.length && showDiscardInfo"
        class="discard-info"
      >
        <my-item
          v-for="item in discardInfo.child"
          :key="item.fieldkey"
          :ref="`item_${item.fieldkey}`"
          :data="fields[item.fieldkey]"
          @change="handleChangeChildItem($event, 'discard_info')"
        />
      </div>
      <!-- 回访提醒时间 -->
      <div
        v-if="remindTime && permissionInfo.is_add_remind"
        class="validator-item border-bottom-1px remind-box"
      >
        <label :data-require="remindTime.isneeded">{{ remindTime.fieldname }}</label>
        <!-- 编辑可点击区域 -->
        <div
          class="fieldValue"
          @click="handleSetRemindModal('edit')"
        >
          <div class="top">
            <span
              v-if="model.time"
              class="time"
            >{{ model.time }}<i class="iconfont iconicon-test18 arrow" /></span>
            <!-- 设置按钮 -->
            <span
              v-if="!model.time"
              class="btn-text set-btn"
              @click="handleSetRemindModal('add')"
            >{{ $t('message["1008"]') }}<i class="iconfont iconicon-test18 arrow" /></span>
          </div>
          <div
            v-if="model.time"
            class="remind-content"
          >
            {{ model.followup_remind_content }}
          </div>
        </div>
      </div>
      <!-- 回访内容 -->
      <div class="follow-content">
        <h2 class="title">
          {{ $t('message["443"]') }} <span class="fs-red">*</span>
        </h2>
        <my-textarea
          ref="item_content"
          :data="fields['content']"
          @change="handleChangeValue($event, fields['content'])"
        />
      </div>
      <!-- 上传图片 -->
      <cube-form-group class="upload-file">
        <h2 class="title">
          {{ $t('message["993"]') }} <span
            v-if="fileData.isneeded"
            class="fs-red"
          >*</span>
        </h2>
        <my-file
          ref="item_uploadFile"
          :data="fileData"
          @change="handleChangeFile"
        />
      </cube-form-group>
    </div>
    <cube-form-group class="cube-picker-footer footer form-btn-box">
      <cube-button
        type="reset"
        class="cancel-btn cube-btn-light"
        @click="handleCancel"
      >
        {{ $t('message["896"]') }}
      </cube-button>
      <cube-button
        type="submit"
        class="confirm-btn cube-btn-primary"
        @click="submitHandler"
      >
        {{ $t('message["915"]') }}
      </cube-button>
    </cube-form-group>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { getRecycleRuleTips } from '@/services/confingAutoWithdraw'
import eventBus from '@/lib/eventBus'
import MyItem from './../create/Item'
import MyTextarea from '@/components/mobile/formItem/Textarea2'
import MyFile from '@/components/mobile/formItem/FileVisit'
import { setCodeData, debounce } from '@/lib/utils'
import { getEncode } from '@/lib/mix'

export default {
  components: {
    MyItem,
    MyTextarea,
    MyFile
  },
  data () {
    return {
      confirmLoading: false,
      scroll: null,
      model: {
        info_type: '',
        info_status: '',
        info_level: '',
        time: '',
        followup_remind_content: '',
        content: '',
        pics: [],
        invalid_info: {},
        deal_info: {},
        discard_info: {}
      },
      fields: {
        'info_type': {},
        'info_status': {},
        'info_level': {},
        'content': {
          fieldkey: 'content',
          fieldtype: 'textarea',
          isneeded: 1,
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["751"]') + ' ' + this.$t('message["443"]')
          }
        },
        'uploadFile': {
          fieldkey: 'uploadFile',
          fieldtype: 'file'
        }
      },
      remindTime: {
        fieldtype: 'datetime',
        fieldkey: 'time',
        fieldname: this.$t('message["447"]'), // 回访提醒
        fieldconfig: {
          placeholder: this.$t('message["877"]'),
          formatdatetime: 2
        },
        isedit: 1
      },
      showInvalid: false,
      showDealInfo: false,
      showDiscardInfo: false,
      errorElements: [], // 存放校验不通过的字段
      recycleRuleTips: '',
      recycleParams: {} // 获取回收提示接口的参数
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'followup',
      'detailData'
    ]),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    inquiryId () {
      return this.$route.params.inquiryId
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    /* 回访配置附加字段，信息分级/信息类型/跟进状态 */
    configAddfields () {
      const { followup_config_addfields: configAddfields = [] } = this.followup || {}
      return configAddfields
    },
    invalidInfo () {
      let { invalid_info: invalidInfo } = JSON.parse(JSON.stringify(this.detailData))
      return invalidInfo
    },
    dealInfo () {
      let { deal_info: dealInfo } = JSON.parse(JSON.stringify(this.detailData))
      return dealInfo
    },
    discardInfo () {
      let { discard_info: discardInfo } = JSON.parse(JSON.stringify(this.detailData))
      return discardInfo
    },

    fileData () {
      return {
        fieldkey: 'uploadFile',
        fieldtype: 'file',
        message: this.$t('message["1600"]'),
        fieldvalue: [],
        isneeded: this.permissionInfo.is_pic_followup,
        accept: '*',
        hideLimitText: true,
        labelname: this.$t('message["993"]'),
        rules: {
          required: this.permissionInfo.is_pic_followup
        },
        messages: {
          required: this.$t('message["1600"]')
        }
      }
    }
  },

  created () {
    this.init()

    this.$bus.$on('setRemind', (remind = {}) => {
      const { time, content } = remind
      this.model.time = time
      this.model.followup_remind_content = content
    })
  },
  methods: {
    ...mapActions('inquery/detailData', [
      'inquiryAddFollowup'
    ]),
    ...mapMutations('inquery/relateData', [
      'UPDATE_IS_INVALID',
      'UPDATE_IS_DISCARD'
    ]),
    ...mapMutations('inquery/detailData', [
      'UPDATE_IS_DEAL',
      'SET_REMIND'
    ]),

    init () {
      if (this.configAddfields.length) {
        // 处理信息类型字段的options和默认选择值
        this.initBaseInfoData()
      }
      if (this.configAddfields.includes('info_type')) {
        // 处理无效相关字段
        this.initInvalidFields()
      }
      if (this.configAddfields.includes('info_status')) {
        this.initDealFields()
        this.initDiscardFields()
      }

      const { time = '', content } = this.followup.remind || {}
      this.model.time = time
      this.remindTime.fieldvalue = time
      this.model.followup_remind_content = content || ''
    },

    hide () {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'baseDetail'
        }
      })
    },
    initBaseInfoData () {
      let { base_info: baseInfo } = this.detailData || {}
      baseInfo.child && baseInfo.child.forEach(item => {
        const { fieldkey } = item
        this.configAddfields.forEach(key => {
          if (fieldkey === key) {
            let options = item.options
            if (item.fieldkey === 'info_type') {
              options = this.setInfoTypeOptions(item)
            }
            // 如果已选择的值不存在于下拉列表（被配置里删除了），清空之前的选择值
            this.model[fieldkey] = !item.fieldvalue ? '' : item.fieldvalue
            let filter = options.filter(one => one.id === this.model[fieldkey])
            if (!filter.length) {
              this.model[fieldkey] = ''
            }
            this.fields[fieldkey] = { ...item }
            this.fields[fieldkey].options = options
            this.fields[fieldkey].fieldvalue = this.model[fieldkey]
          }
        })

        if (item.fieldkey === 'info_type') {
          this.toggleVisibleTypeModule(this.model['info_type'], this.fields['info_type'])
        } else if (fieldkey === 'info_status') {
          this.toggleVisibleStatusModule(this.model['info_status'], this.fields['info_status'])
        }

        // 回收提示
        this.recycleRuleTips = ''
        this.configAddfields.forEach(key => {
          if (fieldkey === key && this.model && this.model[fieldkey]) {
            this.recycleParams[key] = this.model[fieldkey]
          }
        })
        this.getRecycleRuleTips(this.recycleParams, this)
      })
    },

    setInfoTypeOptions (item) {
      let options = [].concat(item.options) || []
      // 录入或审核
      if (this.$route.name === 'InqueryCreate' || this.auditStatus === 0 || this.auditStatus === -1) {
        for (let len = options.length, i = len - 1; i >= 0; i--) {
          if (options[i].visibletype === 2) {
            options.splice(i, 1)
          }
        }
      } else if (this.auditStatus === 1) { // 通过审核的详情
        for (let len = options.length, i = len - 1; i >= 0; i--) {
          if (options[i].visibletype === 1) {
            options.splice(i, 1)
          }
        }
      }
      return options
    },

    toggleVisibleTypeModule (val, data) {
      if (val === '') return
      const { options = [] } = data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      this.showInvalid = name === this.$t('message["1766"]')
      // 是否选择无效
      this.UPDATE_IS_INVALID(this.showInvalid)
    },
    toggleVisibleStatusModule (val, data) {
      if (val === '') return
      const { options = [] } = data || {}
      const filters = options.find(item => item.id === val)
      const name = filters && filters.name
      this.showDealInfo = name === this.$t('message["109"]')
      this.showDiscardInfo = name === this.$t('message["1690"]')
      // 是否选择成交
      this.UPDATE_IS_DEAL(this.showDealInfo)
      // 是否选择丢单
      this.UPDATE_IS_DISCARD(this.showDiscardInfo)
    },

    initInvalidFields () {
      let { child = [] } = this.invalidInfo || {}
      child.forEach((item = {}) => {
        let { fieldkey, fieldvalue } = item
        this.model['invalid_info'][fieldkey] = fieldvalue
        this.fields[fieldkey] = item
      })
    },
    initDealFields () {
      let { child = [] } = this.dealInfo || {}
      child.forEach((item = {}) => {
        let { fieldkey, fieldvalue } = item
        this.model['deal_info'][fieldkey] = fieldvalue
        this.fields[fieldkey] = item
      })
    },
    initDiscardFields () {
      let { child = [] } = this.discardInfo || {}
      child.forEach((item = {}) => {
        let { fieldkey, fieldvalue } = item
        this.model['discard_info'][fieldkey] = fieldvalue
        this.fields[fieldkey] = item
      })
    },

    handleChangeItem (item) {
      let { fieldkey, fieldvalue } = item || {}
      this.model[fieldkey] = fieldvalue

      if (fieldkey === 'info_type') {
        this.toggleVisibleTypeModule(fieldvalue, this.fields['info_type'])
      } else if (fieldkey === 'info_status') {
        this.toggleVisibleStatusModule(fieldvalue, this.fields['info_status'])
      }

      // 回收提示
      this.recycleRuleTips = ''
      this.configAddfields.forEach(key => {
        if (fieldkey === key && this.model[fieldkey]) {
          this.recycleParams[key] = this.model[fieldkey]
        }
      })
      this.getRecycleRuleTips(this.recycleParams, this)
    },
    handleChangeChildItem (item, parentKey) {
      let { fieldkey, fieldvalue } = item || {}
      this.model[parentKey][fieldkey] = fieldvalue
      this.setInvalidInfoParams(item, parentKey)
    },
    handleChangeValue (val, item) {
      let { fieldkey } = item || {}
      this.model[fieldkey] = val
    },

    async setInvalidInfoParams (item = {}, parentKey) {
      const enCode = await getEncode()
      let { fieldtype, fieldkey } = item

      let value = this.model[parentKey][fieldkey]

      const { input = '', address = '', code = {}, treedata = [] } =
            value || {}
      // 加密处理
      // text,editor,area.input,select_tree.input,tag.*,number,email.*,phone.*
      switch (fieldtype) {
        case 'text':
        case 'phone':
        case 'email':
        case 'editor':
        case 'tag':
          this.model[parentKey][fieldkey] = await setCodeData(value, enCode)
          break
        case 'area':
          this.model[parentKey][fieldkey] = this.model[parentKey][fieldkey] || {}
          if (this.$toType(code) === 'object') {
            this.model[parentKey][fieldkey].code = Object.keys(code)
          }
          this.model[parentKey][fieldkey].address = await setCodeData(address, enCode)
          break
        case 'select_tree':
          this.model[parentKey][fieldkey] = this.model[parentKey][fieldkey] || {}
          this.model[parentKey][fieldkey].treedata = treedata
          this.model[parentKey][fieldkey].input = await setCodeData(input, enCode)
          break
        case 'select_reception':
          if (!Array.isArray(value) && value === '- -') {
            this.model[parentKey][fieldkey] = []
          } else {
            this.model[parentKey][fieldkey] = value
          }
          break
        default:
          this.model[parentKey][fieldkey] = value
          break
      }
    },

    handleSetRemindModal (type) {
      let obj = {
        time: this.model.time,
        content: this.model.followup_remind_content
      }
      eventBus.$emit('openSetRemindModal', obj)
    },

    async cancelSetRemind () {
      this.model.time = ''
      this.model.followup_remind_content = ''
    },

    /**
     * 移动端校验
     */
    validateResult () {
      let _this = this
      let hasError = false
      this.errorElements = []
      return new Promise(async (resolve, reject) => {
        for (let k in _this.fields) {
          const field = _this.fields[k] || {}
          const { fieldkey } = field
          let ref = _this.$refs[`item_${fieldkey}`]
          if (this.$toType(ref) === 'array') {
            ref = _this.$refs[`item_${fieldkey}`][0]
          }
          if (ref && ref.validate) {
            ref.validate((result) => {
              // TODO: 异步校验
              // console.log(result, ref.data)

              // 如果无效信息隐藏
              if (this.invalidInfo && this.invalidInfo.child && this.invalidInfo.child.length && !this.showInvalid) {
                this.invalidInfo.child.forEach(item => {
                  if (item.fieldkey === ref.data.fieldkey) {
                    result = true
                  }
                })
              }
              // 如果成交信息隐藏
              if (this.dealInfo && this.dealInfo.child && this.dealInfo.child.length && !this.showDealInfo) {
                this.dealInfo.child.forEach(item => {
                  if (item.fieldkey === ref.data.fieldkey) {
                    result = true
                  }
                })
              }
              // 如果丢单信息隐藏
              if (this.discardInfo && this.discardInfo.child && this.discardInfo.child.length && !this.showDiscardInfo) {
                this.discardInfo.child.forEach(item => {
                  if (item.fieldkey === ref.data.fieldkey) {
                    result = true
                  }
                })
              }

              if (result === false) {
                hasError = true
                this.errorElements.push(ref.$el)
              }
            })
          }
        }
        resolve(hasError)
      })
    },
    /**
     * 滚动到错误的第一个地方
     */
    scrollIntoView () {
      let $scrollElement
      if (this.errorElements[0] && this.errorElements[0].previousSibling) {
        $scrollElement = this.errorElements[0].previousSibling
      } else if (this.errorElements[0]) {
        $scrollElement = this.errorElements[0]
      }
      $scrollElement && $scrollElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    async submitHandler (e) {
      let err = await this.validateResult()
      // console.log(err)
      // 滚动到错误的第一个地方
      this.scrollIntoView()

      if (err) return

      let filter = this.fileData.fieldvalue.filter(item => item.status === 'uploading')
      if (filter.length) {
        this.$notification.error({
          key: 'errorKey',
          message: this.$t('message["748"]'),
          description: this.$t('message["1226"]') + '...'
        })
        return
      }
      if (this.confirmLoading) return
      this.confirmLoading = true
      const params = {
        inquiryid: this.inquiryId,
        content: this.model.content,
        pics: this.model.pics,
        data: {
          base_info: {}
        }
      }
      if (this.model.time) {
        params.followup_remind_time = this.model.time
        params.followup_remind_content = this.model['followup_remind_content']
      }
      if (this.configAddfields.includes('info_type')) {
        params.data['base_info']['info_type'] = this.model['info_type']
        params.data['invalid_info'] = this.model['invalid_info']
      }
      if (this.configAddfields.includes('info_status')) {
        params.data['base_info']['info_status'] = this.model['info_status']
        params.data['deal_info'] = this.model['deal_info']
        params.data['discard_info'] = this.model['discard_info']
      }
      if (this.configAddfields.includes('info_level')) {
        params.data['base_info']['info_level'] = this.model['info_level']
      }

      // 查重详情额外加参数
      if (this.from === 'checkrepeat' && this.checkrepeatfieldkey) {
        params.scope = this.from
        params.checkrepeatfieldkey = this.checkrepeatfieldkey
      }
      const chain = await this.inquiryAddFollowup(params)
      chain
        .onNetSuccess(raw => {
          this.confirmLoading = false
          this.handleCancel()
        })
        .onSuccess(res => {
          // 如果回收提示有值，返回列表
          if (this.recycleRuleTips) {
            let timer = null
            clearTimeout(timer)
            timer = setTimeout(() => {
              this.$router.push({
                name: 'InqueryList',
                query: {
                  type: this.type,
                  from: this.from
                }
              })
            }, 2000)
          } else {
            eventBus.$emit('getFollowupList')
            if (this.configAddfields.length) {
              eventBus.$emit('fetchInquiryDetail')
            }
          }
        })
        .fetch()
    },

    handleCancel () {
      this.hide()
      this.$refs.myForm && this.$refs.myForm.reset()
      this.$refs.uploadFile && this.$refs.uploadFile.resetValidate()

      const { time = '' } = this.followup.remind || {}
      this.remindTime.fieldvalue = time
      this.model.time = time
      this.model.content = ''
      this.model['followup_remind_content'] = ''
      this.model.pics = []
      this.model['info_type'] = ''
      this.model['info_status'] = ''
      this.model['info_level'] = ''

      this.confirmLoading = false
      this.recycleRuleTips = ''
    },
    handleChangeFile (val) {
      this.model.pics = val
    },
    /**
     * 基础信息模块回收提示
      */
    getRecycleRuleTips: debounce(async (params, _this) => {
      try {
        let chain = await getRecycleRuleTips()
        chain
          .params({ rule: params, inquiryid: _this.inquiryId })
          .onSuccess(res => {
            _this.recycleRuleTips = res
          })
          .fetch()
      } catch (error) {
        console.log(error)
      }
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.add-visite {
  width: 100%;
  padding-bottom: 70px;
  background-color: #f5f5f5;
}
::v-deep .quill-editor .ql-container.ql-snow {
  height: 86px;
}
.visibleEle {
  height: 12px;
}
h2.title {
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-size: 16px;
  color: #999;
  background-color: #f5f5f5;
}
.textarea-wrap {
  margin: 0;
  border-radius: 0;
}
.recycle-rule-tips {
  padding: 8px 12px;
  font-size: 12px;
  line-height: 24px;
  color: #FFC06A;
  background-color: #FFF9EC;
  border: solid 1px #F6A953;
  border-left: none;
  border-right: none;
}
.upload-file ::v-deep {
  .title {
    font-size: 14px;
  }
  .cube-upload-file-def,
  .cube-upload-btn-def {
    width: 60px;
    height: 60px;
  }
}
.upload-box {
  padding: 6px 10px;
}
.remind-box {
  .fieldValue {
    flex-flow: column;
  }
  .top {
    display: flex;
    justify-content: space-between;
    flex: 1;
    line-height: 24px;
    padding: 16px 0;
  }
  .time {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .iconfont {
      color: #d6d6d6;
    }
  }
  .set-btn {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-left: 0;
    color: #d6d6d6;
  }
  .remind-content {
    padding-bottom: 12px;
    line-height: 24px;
    color: $gray2;
    font-size: 16px;
    word-break: break-all;
  }
}
.cube-btn {
  width: 48%;
}
</style>
